import { api } from "@/lib/api";

let p = null;
export function presalesStatus() {
  if (!p) p = api.get("/presales/status").then((r) => r.data).catch(() => ({ enabled: false, visible: false }));
  return p;
}
export const PRESALES_NAV = [["Dialling", "/presales"], ["Analytics", "/presales/analytics"], ["Cold-call script", "/presales/script"]];
export const fmtINR = (v) => (v == null ? "—" : "₹" + Math.round(v).toLocaleString("en-IN"));
